/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Company } from './company';
import { Customer } from './customer';
import { LicensePlate } from './license-plate';
import { Person } from './person';
import { RentalCarContract } from './rental-car-contract';
import { RepairPlanRow } from './repair-plan-row';
import { RepairShop } from './repair-shop';
import { Vehicle } from './vehicle';

/**
 * 
 * @export
 * @interface AppsEmployeeDamageCaseData
 */
export interface AppsEmployeeDamageCaseData {
    /**
     * 
     * @type {number}
     * @memberof AppsEmployeeDamageCaseData
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppsEmployeeDamageCaseData
     */
    'imdNetId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppsEmployeeDamageCaseData
     */
    'state'?: AppsEmployeeDamageCaseDataStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppsEmployeeDamageCaseData
     */
    'isPersonInjured': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppsEmployeeDamageCaseData
     */
    'isRecordedByPolice': boolean;
    /**
     * 
     * @type {LicensePlate}
     * @memberof AppsEmployeeDamageCaseData
     */
    'oppositeLicensePlate'?: LicensePlate;
    /**
     * 
     * @type {Person}
     * @memberof AppsEmployeeDamageCaseData
     */
    'oppositePerson'?: Person;
    /**
     * 
     * @type {number}
     * @memberof AppsEmployeeDamageCaseData
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof AppsEmployeeDamageCaseData
     */
    'accidentLocation'?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof AppsEmployeeDamageCaseData
     */
    'vehicle'?: Vehicle;
    /**
     * 
     * @type {Customer}
     * @memberof AppsEmployeeDamageCaseData
     */
    'customer': Customer;
    /**
     * 
     * @type {Company}
     * @memberof AppsEmployeeDamageCaseData
     */
    'lawyerOffice'?: Company;
    /**
     * 
     * @type {string}
     * @memberof AppsEmployeeDamageCaseData
     */
    'lawyerOfficeReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppsEmployeeDamageCaseData
     */
    'damageAssessorReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppsEmployeeDamageCaseData
     */
    'repairShopReferenceNumber'?: string;
    /**
     * 
     * @type {Person}
     * @memberof AppsEmployeeDamageCaseData
     */
    'customerConsultant'?: Person;
    /**
     * 
     * @type {Company}
     * @memberof AppsEmployeeDamageCaseData
     */
    'oppositeInsurance'?: Company;
    /**
     * 
     * @type {RepairShop}
     * @memberof AppsEmployeeDamageCaseData
     */
    'repairShop'?: RepairShop;
    /**
     * 
     * @type {Company}
     * @memberof AppsEmployeeDamageCaseData
     */
    'damageAssessor'?: Company;
    /**
     * 
     * @type {RentalCarContract}
     * @memberof AppsEmployeeDamageCaseData
     */
    'rentalCarContract'?: RentalCarContract;
    /**
     * 
     * @type {Array<RepairPlanRow>}
     * @memberof AppsEmployeeDamageCaseData
     */
    'repairPlanRows'?: Array<RepairPlanRow>;
}

export const AppsEmployeeDamageCaseDataStateEnum = {
    Wait: 'wait',
    Repair100: 'repair_100',
    Repair130: 'repair_130',
    WriteOff: 'write_off'
} as const;

export type AppsEmployeeDamageCaseDataStateEnum = typeof AppsEmployeeDamageCaseDataStateEnum[keyof typeof AppsEmployeeDamageCaseDataStateEnum];


